/// <reference path="../ObjectDataBuilder.ts" />
/// <reference path="../Navigation.ts" />

namespace SPA
{
	export namespace Realtor
	{

		export class SpecialsBuilder
			extends ObjectDataBuilder<Wollmilch.Data.Premise>
		{

			public BoxSpecials = new ui.Box.Box();

			private m_Form: ui.Form.Form;

			public constructor( data: Wollmilch.Data.Premise )
			{
				super( data );

				// Update
				this.m_Form = new ui.Form.Form(
					{
						action: 'premise/update/' + this.m_Data.ID,
						method: 'PATCH',
						static: false,
						notSwitchable: true,
						editButtonContext: 'primary',
						submit: ( method: ui.Form.FormMethod, action: string, parameter: ui.Form.IFormParameter ) =>
						{
							new Wollmilch.AJAX(
								{
									method,
									url: action,
									data: parameter,
									on:
									{
										success: ( text: string ): void =>
										{
											const obj = Wollmilch.jsonize( text );

											if ( obj && obj.success === true )
											{
												app.addToast(
													{
														timeout: Number(app.getConfigValue("ToastTimeout")),
														body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.SPECIALS.success_edit' ) ],
														context: 'success'
													}
												);
											}
											else
											{
												app.addToast(
													{
														timeout: Number(app.getConfigValue("ToastTimeout")),
														body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.SPECIALS.error_edit' ) ],
														context: 'danger'
													}
												);
											}
										}
									}
								},
								Wollmilch.AJAXCallbase_e.REALTOR
							).send();
						}
					}
				);
				this.m_Form.Initialize();
			}

			public rebuild( root: ui.base.BaseHTMLElement|JQuery<HTMLElement>, navigation: Navigation ): SpecialsBuilder
			{
				this.m_Form.rebuild( root );

				this.showCompleteSpecials();

				return this;
			}

			private showCompleteSpecials(): void
			{
				this.showPremiseSpecials();

				// Button
				new ui.Box.Box()
					.append( $( this.m_Form.Buttons.submit.getElement() ).text( app.getMessage( 'Aux.SAVE_BTN' ) ) )
					// .append( $( this.m_Form.Buttons.reset.getElement() ).text( app.getMessage( 'Aux.RESET_BTN' ) ) )
					.append( $( this.m_Form.Buttons.cancel.getElement() ).text( app.getMessage( 'Aux.ABORT_BTN' ) ) )
				.appendTo( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );
			}

			private showPremiseSpecials(): void
			{
				this.BoxSpecials.clearTitle();
				this.BoxSpecials.addTitle( app.getMessage( 'Realtor.OBJECT.TITLE.SPECIALS' ) );
				this.BoxSpecials.rebuild( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) =>
				{
					this.m_Form.Input( input );

					input.Base().addClass( baseclass.join( ' ' ) );
				};

				let fg = ui.$$.div().addClass( 'form-group clearfix' )
				.append(
					ui.$$.h( 6, app.getMessage( 'Realtor.OBJECT.LABEL.SPECIALS.HeritableBuildingRight' ) ).addClass( 'text-muted' )
				).appendTo( this.BoxSpecials.Root() );

				// Erbbaurecht
				{
					const values: string[] = [];

					for ( const i in this.m_Data.Data.Specials.HeritableBuildingRight.heritable )
					{
						if ( this.m_Data.Data.Specials.HeritableBuildingRight.heritable[ i ] ) { values.push( i.toLowerCase() ); }
					}

					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'Specials.HeritableBuildingRight.heritable',
								required: false,
								inline: 1,
								value: values,
								checkboxes:
								[
									{
										name: 'heritable',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.SPECIALS.HeritableBuildingRight.heritable' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild(
							ui.$$.div().addClass( 'form-group clearfix' )
							.append(
								ui.$$.label().text(
									app.getMessage( 'Realtor.OBJECT.LABEL.SPECIALS.heritable' )
								).addClass( 'control-label col-xs-12 col-md-2' )
							).appendTo( this.BoxSpecials.Root() )
						),
						[ 'col-xs-12', 'col-md-10' ]
					);
				}

				// Restlaufzeit
				fg = ui.$$.div()
				.addClass( 'form-group' )
				.append(
					ui.$$.label().text(
						app.getMessage( 'Realtor.OBJECT.INPUT.SPECIALS.HeritableBuildingRight.RemainingTime' )
					).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.BoxSpecials.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.Specials.HeritableBuildingRight.RemainingTime,
						{
							name: 'Specials.HeritableBuildingRight.RemainingTime',
							placeholder: '',
							required: false,
							min: 0
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' )
				.append(
					ui.$$.label().text(
						app.getMessage( 'Realtor.OBJECT.INPUT.SPECIALS.HeritableBuildingRight.HeritableInterest' )
					).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.BoxSpecials.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.Specials.HeritableBuildingRight.HeritableInterest,
						{
							name: 'Specials.HeritableBuildingRight.HeritableInterest',
							placeholder: '',
							required: false,
							min: 0
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				// Baulasten
				fg = ui.$$.div().addClass( 'form-group clearfix' )
					.append( ui.$$.h( 6, app.getMessage( 'Realtor.OBJECT.LABEL.SPECIALS.PublicEasement' ) ).addClass( 'text-muted' ) )
					.appendTo( this.BoxSpecials.Root() );

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' )
				.append(
					ui.$$.label().text(
						app.getMessage( 'Realtor.OBJECT.INPUT.SPECIALS.PublicEasement.Information' )
					).addClass( 'control-label col-xs-12 col-md-2' )
				)
				.appendTo( this.BoxSpecials.Root() );
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.Specials.PublicEasement.Information || '',
						{
							name: 'Specials.PublicEasement.Information',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' )
				.append(
					ui.$$.label().text(
						app.getMessage( 'Realtor.OBJECT.INPUT.SPECIALS.Easement.EasementBWS' )
					).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.BoxSpecials.Root() );
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.Specials.Easement.EasementBWS || '',
						{
							name: 'Specials.Easement.EasementBWS',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-10' ]
				);

			}

		}
	}
}
